export enum TranslationKey {
  INIT_BUBBLE_MESSAGE = "INIT_BUBBLE_MESSAGE",
  QUESTION_ABOUT_WEB_APPS = "QUESTION_ABOUT_WEB_APPS",
  ANSWER_ABOUT_WEB_APPS = "ANSWER_ABOUT_WEB_APPS",
  QUESTION_ABOUT_WEBSITES = "QUESTION_ABOUT_WEBSITES",
  ANSWER_ABOUT_WEBSITES = "ANSWER_ABOUT_WEBSITES",
  QUESTION_ABOUT_MODERN_TECHNOLOGIES = "QUESTION_ABOUT_MODERN_TECHNOLOGIES",
  ANSWER_ABOUT_MODERN_TECHNOLOGIES = "ANSWER_ABOUT_MODERN_TECHNOLOGIES",
  QUESTION_ABOUT_EDUCATION = "QUESTION_ABOUT_EDUCATION",
  ANSWER_ABOUT_EDUCATION = "ANSWER_ABOUT_EDUCATION",
  QUESTION_ABOUT_EXPERIENCE = "QUESTION_ABOUT_EXPERIENCE",
  ANSWER_ABOUT_EXPERIENCE = "ANSWER_ABOUT_EXPERIENCE",
  SERVICES = "SERVICES",
  SERVICES_SHORT_DESCRIPTION = "SERVICES_SHORT_DESCRIPTION",
  SERVICES_DESCRIPTION = "SERVICES_DESCRIPTION",
  SERVICES_DESCRIPTION_SUMMARY = "SERVICES_DESCRIPTION_SUMMARY",
  WEB_APPS_SITES = "WEB_APPS_SITES",
  WEB_APPS_SITES_SERVICE_SHORT_DESCRIPTION = "WEB_APPS_SITES_SERVICE_SHORT_DESCRIPTION",
  WEB_APPS_SITES_SERVICE_DESCRIPTION = "WEB_APPS_SITES_SERVICE_DESCRIPTION",
  CODING = "CODING",
  CODING_SERVICE_SHORT_DESCRIPTION = "CODING_SERVICE_SHORT_DESCRIPTION",
  CODING_SERVICE_DESCRIPTION = "CODING_SERVICE_DESCRIPTION",
  SERVER_DOMAIN = "SERVER_DOMAIN",
  SERVER_DOMAIN_SERVICE_SHORT_DESCRIPTION = "SERVER_DOMAIN_SERVICE_SHORT_DESCRIPTION",
  SERVER_DOMAIN_SERVICE_DESCRIPTION = "SERVER_DOMAIN_SERVICE_DESCRIPTION",
  MORE_ABOUT_SERVICES = "MORE_ABOUT_SERVICES",
  STEPS = "STEPS",
  STEPS_SHORT_DESCRIPTION = "STEPS_SHORT_DESCRIPTION",
  NEED_ANALYSIS_STEP_TITLE = "NEED_ANALYSIS_STEP_TITLE",
  NEED_ANALYSIS_STEP_DESCRIPTION = "NEED_ANALYSIS_STEP_DESCRIPTION",
  GRAPHIC_DESIGN_STEP_TITLE = "GRAPHIC_DESIGN_STEP_TITLE",
  GRAPHIC_DESIGN_STEP_DESCRIPTION = "GRAPHIC_DESIGN_STEP_DESCRIPTION",
  CREATING_APP_STEP_TITLE = "CREATING_APP_STEP_TITLE",
  CREATING_APP_STEP_DESCRIPTION = "CREATING_APP_STEP_DESCRIPTION",
  SUPPORT_STEP_TITLE = "SUPPORT_STEP_TITLE",
  SUPPORT_STEP_DESCRIPTION = "SUPPORT_STEP_DESCRIPTION",
  TECHNOLOGIES = "TECHNOLOGIES",
  TECHNOLOGIES_SHORT_DESCRIPTION = "TECHNOLOGIES_SHORT_DESCRIPTION",
  ABOUT_ME = "ABOUT_ME",
  ABOUT_ME_SHORT_DESCRIPTION = "ABOUT_ME_SHORT_DESCRIPTION",
  CONTACT = "CONTACT",
  WORKS = "WORKS",
  ABOUT_ME_DESCRIPTION = "ABOUT_ME_DESCRIPTION",
  ABOUT_COMPANY = "ABOUT_COMPANY",
  ABOUT_COMPANY_DESCRIPTION = "ABOUT_COMPANY_DESCRIPTION",
  WORKS_DESCRIPTION = "WORKS_DESCRIPTION",
  USED_TECHNOLOGIES = "USED_TECHNOLOGIES",
  COOKIES_SHORT_DESCRIPTION = "COOKIES_SHORT_DESCRIPTION",
  COOKIES_POLICY_DESCRIPTION = "COOKIES_POLICY_DESCRIPTION",
  COOKIES_POLICY = "COOKIES_POLICY",
  PAGE_NOT_FOUND = "PAGE_NOT_FOUND",
  SERVER_ERROR = "SERVER_ERROR",
  SERVER_ERROR_MESSAGE = "SERVER_ERROR_MESSAGE",
  BLOG = "BLOG",

  // *** Works data ***
  INVOICE_CONVERTER_TITLE = "INVOICE_CONVERTER_TITLE",
  INVOICE_CONVERTER_DESCRIPTION = "INVOICE_CONVERTER_DESCRIPTION",
  EDUCATION_GAME_TITLE = "EDUCATION_GAME_TITLE",
  EDUCATION_GAME_DESCRIPTION = "EDUCATION_GAME_DESCRIPTION",

  // *** Route meta data ***
  HOME_PATH_TITLE = "HOME_PATH_TITLE",
  HOME_PATH_DESCRIPTION = "HOME_PATH_DESCRIPTION",
  HOME_PATH_KEYWORDS = "HOME_PATH_KEYWORDS",
  ABOUT_PATH_TITLE = "ABOUT_PATH_TITLE",
  ABOUT_PATH_DESCRIPTION = "ABOUT_PATH_DESCRIPTION",
  ABOUT_PATH_KEYWORDS = "ABOUT_PATH_KEYWORDS",
  SERVICES_PATH_TITLE = "SERVICES_PATH_TITLE",
  SERVICES_PATH_DESCRIPTION = "SERVICES_PATH_DESCRIPTION",
  SERVICES_PATH_KEYWORDS = "SERVICES_PATH_KEYWORDS",
  WORKS_PATH_TITLE = "WORKS_PATH_TITLE",
  WORKS_PATH_DESCRIPTION = "WORKS_PATH_DESCRIPTION",
  WORKS_PATH_KEYWORDS = "WORKS_PATH_KEYWORDS",
  COOKIES_POLICY_PATH_TITLE = "COOKIES_POLICY_PATH_TITLE",
  COOKIES_POLICY_PATH_DESCRIPTION = "COOKIES_POLICY_PATH_DESCRIPTION",
  COOKIES_POLICY_PATH_KEYWORDS = "COOKIES_POLICY_PATH_KEYWORDS",
  NOT_FOUND_PATH_TITLE = "NOT_FOUND_PATH_TITLE",
  BLOG_PATH_TITLE = "BLOG_PATH_TITLE",
  BLOG_PATH_DESCRIPTION = "BLOG_PATH_DESCRIPTION",
  BLOG_PATH_KEYWORDS = "BLOG_PATH_KEYWORDS",

  // *** Route paths ***
  ABOUT_PATH = "ABOUT_PATH",
  SERVICES_PATH = "SERVICES_PATH",
  WORKS_PATH = "WORKS_PATH",
  COOKIES_POLICY_PATH = "COOKIES_POLICY_PATH",
  BLOG_PATH = "BLOG_PATH",
}

type Translation = {
  [key in TranslationKey]: string;
};

export default Translation;
